import request from '@/utils/request'

//获取课程讨论区评论列表
export function commentList(data) {
	return request({
		url: '/api/comment/list',
		method: 'get',
		params: data
	})
} 

//发布评论
export function commentPublish(data) {
	return request({
		url: '/api/comment/publish',
		method: 'post',
		data
	})
}

//点赞
export function commentLike(data) {
	return request({
		url: '/api/comment/like?commentId='+data.commentId,
		method: 'post',
		data
	})
}
//取消点赞
export function commentCancelLikes(data) {
	return request({
		url: '/api/comment/cancelLikes?commentId='+data.commentId,
		method: 'post',
		data
	})
}

//我的评论
export function mycommentList(data) {
	return request({
		url: '/api/comment/my',
		method: 'get',
		params: data
	})
} 

//发布回复
export function replyPublish(data) {
	return request({
		url: '/api/reply/publish',
		method: 'post',
		data
	})
}
//更多回复
export function replyService(data) {
	return request({
		url: '/api/reply/replyService',
		method: 'get',
		params: data
	})
}

//获取实验讨论区评论列表
export function vrcommentList(data) {
	return request({
		url: '/simulation/tVrResourceDetailCommentDO/listComment',
		method: 'get',
		params: data
	})
} 

//发布评论
export function vrcommentPublish(data) {
	return request({
		url: '/simulation/tVrResourceDetailCommentDO/publish',
		method: 'post',
		data
	})
}


//点赞
export function vrcommentLike(data) {
	return request({
		url: '/simulation/tVrResourceDetailCommentDO/commonLike',
		method: 'get',
		params: data
	})
}

//取消点赞
export function vrcommentCancelLikes(data) {
	return request({
		url: '/simulation/tVrResourceDetailCommentDO/commonCancelLike',
		method: 'get',
		params: data
	})
}


//我的评论
export function vrmycommentList(data) {
	return request({
		url: '/simulation/tVrResourceDetailCommentDO/myComment',
		method: 'get',
		params: data
	})
} 

//实验评论回复
export function vrreplyPublish(data) {
	return request({
		url: '/simulation/tVrResourceDetailCommentDO/replyPublish',
		method: 'post',
		data
	})
}
//根据评论id查询回复列表
export function vrreplyService(data) {
	return request({
		url: '/simulation/tVrResourceDetailCommentDO/replyList',
		method: 'get',
		params: data
	})
}




